import { render, staticRenderFns } from "./PanelGroup.vue?vue&type=template&id=1d5e7fb6&"
import script from "./PanelGroup.vue?vue&type=script&lang=js&"
export * from "./PanelGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PROJETS\\VITISSIA\\2024\\vitissiapro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d5e7fb6')) {
      api.createRecord('1d5e7fb6', component.options)
    } else {
      api.reload('1d5e7fb6', component.options)
    }
    module.hot.accept("./PanelGroup.vue?vue&type=template&id=1d5e7fb6&", function () {
      api.rerender('1d5e7fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/Dashboard/PanelGroup.vue"
export default component.exports